import { DateTime } from 'luxon'
import { getWeekStart } from './dates'

export const dateRangeForRelativeValue = (
  value: RelativeDateRangeValue,
  weekStartsOn: 'monday' | 'sunday',
): { startDate: DateTime; endDate: DateTime } => {
  const today = DateTime.now().startOf('day')

  switch (value) {
    case 'today':
      return { startDate: today, endDate: today.endOf('day') }
    case 'thisWeek': {
      const weekStart = getWeekStart(today, weekStartsOn)

      return {
        startDate: weekStart,
        endDate: weekStart.plus({ days: 6 }).endOf('day'),
      }
    }
    case 'lastWeek': {
      const lastWeekDate = today.minus({ weeks: 1 })
      const lastWeekStart = getWeekStart(lastWeekDate, weekStartsOn)

      return {
        startDate: lastWeekStart,
        endDate: lastWeekStart.plus({ days: 6 }).endOf('day'),
      }
    }
    case 'thisMonth':
      return {
        startDate: today.startOf('month'),
        endDate: today.endOf('month').endOf('day'),
      }
    case 'lastMonth':
      return {
        startDate: today.minus({ months: 1 }).startOf('month'),
        endDate: today.minus({ months: 1 }).endOf('month').endOf('day'),
      }
    case 'thisYear':
      return {
        startDate: today.startOf('year'),
        endDate: today.endOf('year').endOf('day'),
      }
    case 'weekToDate': {
      const weekStart = getWeekStart(today, weekStartsOn)

      return {
        startDate: weekStart,
        endDate: today.endOf('day'),
      }
    }
    case 'monthToDate':
      return {
        startDate: today.startOf('month'),
        endDate: today.endOf('day'),
      }
    case 'yearToDate':
      return {
        startDate: today.startOf('year'),
        endDate: today.endOf('day'),
      }
  }
}
